import type { ReactNode } from 'react';
import { cn } from '../cn.ts';

// A quiet pill: neutral background, the tone carried by a small dot.
const dots = {
  neutral: 'bg-muted',
  ok: 'bg-ok-fg',
  warn: 'bg-warn-fg',
  bad: 'bg-bad-fg',
  info: 'bg-info-fg',
  brand: 'bg-brand',
} as const;

export type Tone = keyof typeof dots;

export function Badge({ tone = 'neutral', children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-white px-2 py-0.5 text-xs font-medium text-mid ring-1 ring-inset ring-line', className)}>
      {tone !== 'neutral' && <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', dots[tone])} aria-hidden />}
      {children}
    </span>
  );
}
